/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyVendor } from '../models/SurveyVendor';
import type { SurveyVendorAdmin } from '../models/SurveyVendorAdmin';
import type { SurveyVendorAdminRequest } from '../models/SurveyVendorAdminRequest';
import type { SurveyVendorRequest } from '../models/SurveyVendorRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminSurveyVendorService {

    /**
     * get list of survey vendors
     * @returns any Success
     * @throws ApiError
     */
    public static listAdminSurveyVendors({
        limit,
        offset,
        search,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Search by name or code
         */
        search?: string,
    }): CancelablePromise<{
        rows?: Array<SurveyVendorAdmin>;
        count?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyVendor',
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create SurveyVendor
     * @returns SurveyVendor Success
     * @throws ApiError
     */
    public static createSurveyVendor({
        requestBody,
    }: {
        requestBody: SurveyVendorRequest,
    }): CancelablePromise<SurveyVendor> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyVendor',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Survey Vendor Information
     * @returns SurveyVendorAdmin Success
     * @throws ApiError
     */
    public static updateSurveyVendor({
        id,
        requestBody,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
        requestBody: SurveyVendorAdminRequest,
    }): CancelablePromise<SurveyVendorAdmin> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/surveyVendor/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Vendor
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyVendor({
        id,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/surveyVendor/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * upload image
     * @returns any Success
     * @throws ApiError
     */
    public static uploadSurveyVendor({
        formData,
    }: {
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<{
        key?: string | null;
        url?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyVendor/image',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List files and folders for a vendor
     * @returns any Success
     * @throws ApiError
     */
    public static listSurveyVendorFiles({
        id,
        prefix,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
        /**
         * Relative sub-path within the vendor's files root (e.g. "contracts")
         */
        prefix?: string,
    }): CancelablePromise<{
        folders?: Array<{
            name?: string;
            key?: string;
        }>;
        files?: Array<{
            name?: string;
            key?: string;
            size?: number | null;
            lastModified?: string | null;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyVendor/{id}/files',
            path: {
                'id': id,
            },
            query: {
                'prefix': prefix,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete a file or folder (folder deletes all contents recursively)
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyVendorFile({
        id,
        requestBody,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
        requestBody: {
            /**
             * Full S3 key of the file or folder (folders end with /)
             */
            key: string;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/surveyVendor/{id}/files',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a folder for a vendor
     * @returns any Success
     * @throws ApiError
     */
    public static createSurveyVendorFolder({
        id,
        requestBody,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
        requestBody: {
            folderName: string;
            /**
             * Parent sub-path within the vendor's files root (e.g. "contracts")
             */
            prefix?: string;
        },
    }): CancelablePromise<{
        key?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyVendor/{id}/files/folder',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Upload a file for a vendor
     * @returns any Success
     * @throws ApiError
     */
    public static uploadSurveyVendorFile({
        id,
        formData,
        prefix,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
        formData: {
            file?: Blob;
        },
        /**
         * Sub-path within the vendor's files root to upload into (e.g. "contracts")
         */
        prefix?: string,
    }): CancelablePromise<{
        key?: string;
        name?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyVendor/{id}/files/upload',
            path: {
                'id': id,
            },
            query: {
                'prefix': prefix,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get a presigned download URL for a vendor file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadSurveyVendorFile({
        id,
        key,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
        /**
         * Full S3 key of the file
         */
        key: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyVendor/{id}/files/download',
            path: {
                'id': id,
            },
            query: {
                'key': key,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
